import "@/components/keenicons/assets/styles.css";
import "./styles/globals.css";
import axios from "axios";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { setupAxios } from "./auth";
import { ProvidersWrapper } from "./providers";
// React import retained only if needed by JSX transform
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

/**
 * Inject interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      staleTime: 30_000,
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<React.StrictMode>
//     <ProvidersWrapper>
//       <App />
//     </ProvidersWrapper>
//   </React.StrictMode>);
root.render(
  <ProvidersWrapper>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen />
      <App />
    </QueryClientProvider>
  </ProvidersWrapper>
);
